import {useParams} from "react-router-dom";
import {getTitles} from "../data/data";
import styled from 'styled-components';
import React from "react";
import {ImageInfo} from "./images/ImageInfo";
import {Image} from "semantic-ui-react";
import {useGotoCompetition} from "./hooks/useGotoCompetition";

const titles = getTitles();

export const ImageView = () => {
    const params = useParams();
    const id = params.id;
    const title = titles.find(t => t.imageId === id);
    const gotoCompetition = useGotoCompetition({title});

    return <>
        <Header>
            <div>
                <Image src={"/resultater/images/logo-darkgreen.png"} alt="Logo" height={"60"}/>
            </div>
            <div onClick={() => gotoCompetition()}>
                <div>{title.competition}</div>
                <div>{title.class} - {title.theme}</div>
            </div>
            <div></div>
        </Header>

        <ImageInfo title={title}/>
    </>
}

const Header = styled.div`
  height: 70px;
  background-color: #90b361;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #36501c;
  font-family: 'Fibon Neue';

  > div {
    display: flex;
    flex-direction: row;
    margin-left: 10px;

    > div {
      margin-left: 20px;
    }

    align-items: center;
  }

  > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;

    > div:nth-child(1) {
      font-size: 1.4rem;
    }
  }

  > div:nth-child(3) {
    margin-right: 20px;
  }
`
